import { loadRemote, registerRemotes } from '@module-federation/enhanced/runtime';
function bustUrlCache(urlString) {
  const url = new URL(urlString);
  url.searchParams.set('t', Date.now().toString());
  return url.toString();
}
export async function loadRemoteModule(_ref) {
  let {
    module,
    scope,
    url,
    bustRemoteEntryCache
  } = _ref;
  registerRemotes([{
    name: scope,
    entry: bustRemoteEntryCache ? bustUrlCache(url) : url
  }], {
    force: bustRemoteEntryCache
  });
  const loadRemoteRequest = `${scope}/${module.replace('./', '')}`;
  const loadedRemote = await loadRemote(loadRemoteRequest);
  if (loadedRemote === null) {
    throw new Error(`ExoSkeletonAPI Error: Failed to load remote "${module}" from scope "${scope}". Load remote request: "${loadRemoteRequest}"`);
  }
  return loadedRemote;
}
//# sourceMappingURL=loadRemoteModule.js.map